// extracted by mini-css-extract-plugin
export default {"ButtonRow":"DownloadTermsSection_ButtonRow__UBg2z","downloadPStyles":"DownloadTermsSection_downloadPStyles__hOdKk"};